import { observer } from "mobx-react";
import FontBody2 from "../../../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../../components/fonts/font-props";
import RefundCalculatorStore from "../../../../stores/refund-calculator-store";
import Currency from "../../../../../../../components/currency/currency";
import "./suggested-refund.scss";
import FontHeading3 from "../../../../../../../components/fonts/font-heading3/font-heading3";
import useDashboardTranslation from "../../../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface ISuggestedRefundProps {
    calculatorStore: RefundCalculatorStore;
}

const SuggestedRefund: React.FC<ISuggestedRefundProps> = observer(({calculatorStore}) => {

    
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-returns-rma-card';

    const title = calculatorStore.getSuggestedRefund() < 0 ? getTranslation('PENDING_CUSTOMER_PAYMENTS', pageScope) : getTranslation('SUGGESTED_REFUND', pageScope);
    
    return (
        <>
            <div className="suggested-refund">
                <div className="suggested-refund-text">
                    <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{title}</FontBody2>
                    {!!calculatorStore.shouldShowShopCurrency() &&
                        <FontBody2 color={FONT_COLOR.PRIMARY3_50}>1 {calculatorStore.paymentCurrency} = {calculatorStore.conversionRate} {calculatorStore.shopCurrency}</FontBody2>
                    }
                </div>
                <div className="suggested-refund-text">
                    <FontHeading3 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                        <Currency amount={calculatorStore.getSuggestedRefund()} currencyCode={calculatorStore.paymentCurrency} />
                    </FontHeading3>
                    {!!calculatorStore.shouldShowShopCurrency() &&
                        <FontBody2 color={FONT_COLOR.PRIMARY3_50}>
                            <Currency amount={calculatorStore.getSuggestedRefundInShopCurrency()} currencyCode={calculatorStore.shopCurrency} />
                        </FontBody2>
                    }
                </div>
            </div>
        </>
    )
});

export default SuggestedRefund;